Ext.define('SA.EditPanelBuilder', {
    statics: {
        forAttributes() {
            return new SA.EditPanelBuilder()
                .setTitle('Data')
                .setItemLabelFactory(SA.EditItemLabelFactory.forAttributes())
                .setDisabledSectionMessage('These variables are not supported by this view type');
        },

        forBusinesses() {
            return new SA.EditPanelBuilder()
                .setTitle('Businesses')
                .setItemLabelFactory(SA.EditItemLabelFactory.forBusinesses());
        },

        forLocations() {
            return new SA.EditPanelBuilder()
                .setTitle('Locations')
                .setItemLabelFactory(SA.EditItemLabelFactory.forLocations())
                .setDisabledSectionMessage('These locations are not supported by this view type');
        }
    },

    constructor() {
        this.disabledSections = [];
    },

    build() {
        var itemFactory = this.itemFactory ?? SA.EditCheckFieldFactory.create({xtype: this.itemXtype, labelFactory: this.itemLabelFactory}),
            enabledSection = new SA.EditPanelEnabledSectionController({itemFactory}),
            disabledSections = this.buildDisabledSections(),
            headerSelectionButtons = Ext.widget({xtype: 'edit-panel-header-selection-buttons', hidden: !this._withSelectionButtons}),
            subheader = this.subheader,
            view = Ext.widget({
                xtype: 'edit-panel',
                title: this.title,
                headerSelectionButtons,
                subheader,
                enabledSection: enabledSection.getView(),
                disabledSections: disabledSections.getViews()
            });

        return new SA.EditPanelController({view, headerSelectionButtons, subheader, enabledSection, disabledSections});
    },

    buildDisabledSections() {
        var configs = this.disabledSections,
            itemFactory = id => Ext.widget({xtype: 'edit-panel-disabled-item', labelFactory: this.itemLabelFactory, dataId: id}),
            createSectionController = section => new SA.EditPanelDisabledSectionController({itemFactory, ...section});

        if (configs.length === 0 && this.disabledSectionMessage) {
            configs = [{message: this.disabledSectionMessage}];
        }

        return new SA.EditPanelDisabledSectionsController(configs.map(section => createSectionController(section)));
    },

    addDisabledSection(disabledSection) {
        this.disabledSections.push(disabledSection);
        return this;
    },

    set(param) {
        return Object.assign(this, param);
    },

    setDisabledSectionMessage(disabledSectionMessage) {
        return this.set({disabledSectionMessage});
    },

    setItemFactory(itemFactory) {
        return this.set({itemFactory});
    },

    setItemLabelFactory(itemLabelFactory) {
        return this.set({itemLabelFactory});
    },

    setSubheader(subheader) {
        return this.set({subheader});
    },

    setTitle(title) {
        return this.set({title});
    },

    withCheckboxes() {
        return this.set({itemXtype: 'sa-checkbox'});
    },

    withRadios() {
        return this.set({itemXtype: 'sa-radio'});
    },

    withSelectionButtons() {
        return this.set({_withSelectionButtons: true});
    }
});